<div class="rewards-card">
  <div class="card-view">
    <h4 class="card-title">Rewards Calculator</h4 >

    <div class="tabs-container">
      <!-- <div class="tabs-row">
        <div
          class="tab"
          *ngFor="let tab of cardTypes; let i = index"
          [ngClass]="{ 'active-tab': selectedTabIndex === i }"
          (click)="selectTab(i)"
        >
          {{ tab }}
        </div>
      </div> -->

      <div class="tab-content">

        <div class="form-row">
          <!-- Left: Monthly Spends Grid -->
          <div class="monthly-spend-column">

            <div class="country-row">
              <div class="dropdown-group">
                <h5>Country</h5>
                <select [(ngModel)]="selectedCountry" (change)="onCountryChange()">
                  <option value="" disabled selected>Select Country</option>
                  <option *ngFor="let country of countries" [value]="country.name">
                    {{ country.emoji }} {{ country.name }}
                  </option>
                </select>
              </div>

              <div class="dropdown-group">
                <h5>Card Type</h5>
                <select [(ngModel)]="selectedCardTypeKey" (change)="onCardTypeChange($event.target.value)" required>
                  <option value="" disabled selected>Select Card Type</option>
                  <option *ngFor="let type of typeOptions" [value]="type">{{ type }}</option>
                </select>
              </div>

              <div class="dropdown-group">
                <h5>Card</h5>
                <select [(ngModel)]="selectedCard" (ngModelChange)="onCardChange($event)" [disabled]="!cardList.length"
                  required>
                  <option value="" disabled selected>Select Card</option>
                  <option *ngFor="let card of cardList" [value]="card">{{ card }}</option>
                </select>
              </div>
            </div>


            <div class="dropdown-inline-group d-flex align-items-center mb-3">
              <div class="custom-select-wrapper me-2">
                <select class="custom-select" [(ngModel)]="selectedPeriod" (change)="onPeriodChange()">
                  <option value="Monthly">Monthly</option>
                  <option value="Yearly" selected>Yearly</option>
                </select>
              </div>
              <h5 class="section-heading mb-0">payments for:</h5>
            </div>

            <div class="grid-box">
              <div
                class="input-card"
                *ngFor="let field of expenseFields; let i = index"
                [class.filled]="field.value"
              >
                <label>{{ field.label }}</label>
                <div class="input-wrapper">
                  <input
                  type="text"
                  [value]="field.touched ? field.value : '0'"
                  (input)="onAmountChange($event.target.value, field)"
                  (keydown)="onKeyDown($event, i)"
                  maxlength="15"
                  inputmode="numeric"
                  class="form-control"
                />              
                  <span class="currency-suffix">{{ currencySuffix }}</span>
                </div>
              </div>
            </div>
            
            

            <div *ngIf="(milesEarned !== 0 && selectedCard) " class="total-info-wrapper">

              <div class="total-info-row" *ngIf="selectedCard && selectedCardTypeValue !== 'Business'">
                <strong>Total Savings (miles) p.a:</strong>
                <span>
                  {{ Math.round(totalSavingsMiles) }} <span class="currency-color">{{ currencySuffix }}</span>
                </span>
              </div>
            
              <div class="total-info-row" *ngIf="selectedCard && selectedCardTypeValue === 'Business'">
                <strong>Savings from Miles p.a:</strong>
                <span>
                  {{ Math.round(totalSavingsMiles) }} <span class="currency-color">{{ currencySuffix }}</span>
                </span>
              </div>
            
              <div class="total-info-row" *ngIf="selectedCardTypeValue === 'Business' && interestAmount !== null && (milesEarned === 0) &&(miles !== null && miles === false)">
                <strong>Savings from Interest p.a:</strong>
                <span>
                  {{ Math.round(interestAmount) }} <span class="currency-color">{{ currencySuffix }}</span>
                </span>
              </div>
            
              <div class="total-info-row" *ngIf="selectedCard && selectedCardTypeValue === 'Business' && totalsavingbusiness !== null">
                <strong>Total Savings p.a:</strong>
                <span>
                  {{ Math.round(totalsavingbusiness) }} <span class="currency-color">{{ currencySuffix }}</span>
                </span>
              </div>
            
              <div class="total-info-row" *ngIf="selectedCard && cardFeesPa !== null">
                <strong>Total Cost (Card Fees: {{ costPercent }}%):</strong>
                <span>
                  {{ Math.round(cardFeesPa) }} <span class="currency-color">{{ currencySuffix }}</span>
                </span>
              </div>
            
              <div class="total-info-row" *ngIf="selectedCard && selectedCardTypeValue === 'Business' && netSavingsBusiness !== null">
                <strong>Net Savings p.a:</strong>
                <span>
                  {{ Math.round(netSavingsBusiness) }} <span class="currency-color">{{ currencySuffix }}</span>
                </span>
              </div>
            
              <div class="total-info-row" *ngIf="selectedCard && selectedCardTypeValue !== 'Business' && netSavingsMiles !== null">
                <strong>Net Savings p.a:</strong>
                <span>
                  {{ Math.round(netSavingsMiles) }} <span class="currency-color">{{ currencySuffix }}</span>
                </span>
              </div>
            
            </div>
            
            
            

          </div>

          <!-- Right: Card Dropdown -->
          <div class="form-column">


            <!-- Airline Dropdown -->
            <!-- Main Column Wrapper (Shown only if milesEarned !== 0) -->
            <div *ngIf="milesEarned !== 0" class="rewards-column-wrapper">

              <!-- Airline Dropdown -->
              <div class="dropdown">
                <label for="airlineSelect">Select Airline:</label>
                <select id="airlineSelect" [(ngModel)]="selectedAirline" (change)="onAirlineChange()">
                  <option *ngFor="let airline of airlinesList" [value]="airline">{{ airline }}</option>
                </select>
              </div>

              <!-- Class Toggle Button -->
              <div class="toggle-tab-container">
                <label for="classToggle">Select Class:</label>
                <div class="toggle-tab-bar">
                  <div class="tab" [ngClass]="{ 'active-tab': selectedClass === 'Economy' }"
                    (click)="selectClass('Economy')">
                    Economy
                  </div>
                  <div class="tab" [ngClass]="{ 'active-tab': selectedClass === 'Business' }"
                    (click)="selectClass('Business')">
                    Business
                  </div>
                </div>
              </div>

              <!-- Trip List Dropdown -->
              <div class="dropdown">
                <label for="tripSelect">Select Trip:</label>
                <select id="tripSelect" [(ngModel)]="selectedTrip" (change)="onTripChange()">
                  <option *ngFor="let trip of tripList" [value]="trip">{{ trip }}</option>
                </select>
              </div>

              <!-- Borrowing Rate Input for Business Card -->
              <div *ngIf="selectedCardTypeValue === 'Business'" class="d-flex flex-column gap-1 mt-3">
                <div class="d-flex flex-row align-items-center gap-2">
                  <label for="borrowingRate" class="fw-bold mb-0">Borrowing Rate(%) p.a</label>

                  <div class="borrowing-wrapper d-flex flex-row align-items-center gap-2">
                    <input id="borrowingRate" type="text" class="borrowing-input" maxlength="5" inputmode="decimal"
                      placeholder="e.g. 1" [(ngModel)]="borrowingRate" (ngModelChange)="calculateInterestAmount()"
                      pattern="[0-9]*([.][0-9]+)?"
                      style="text-align: right;"
                      (keydown)="restrictToNumbersOnly($event)" />
                    <span class="suffix-percent">%</span>
                  </div>
                </div>

                <div class="text-muted" style="font-size: 0.8rem; margin-top: 10px; max-width: 400px;">
                  If you are using a line of credit or any other form of finance, please input the annualized rate of
                  borrowing, else input 0%
                </div>
              </div>

              <div class="miles-summary-wrapper">
                <!-- Annual Expenses -->
                <div class="miles-summary-row">
                  <strong>Your annual expenses:</strong>
                  <span>{{ totalAnnualExpense | number: '1.0-0' }}  <span class="currency-color"> {{currencySuffix }}</span></span>
                </div>
              
                <!-- Required Miles -->
                <div class="miles-summary-row">
                  <strong>Required Miles:</strong>
                  <span>{{ milesNeeded | number: '1.0-0' }}</span>
                </div>

                   <!-- Earned Miles -->
                  <div *ngIf="milesYouEarned !== null" class="miles-summary-row">
                      <strong>Miles You Earned:</strong>
                      <span>{{ (this.totalAnnualExpense * this.milesEarned) | number: '1.0-0' }}</span>
                    </div>

                           <!-- Enter Existing Miles -->
                <div class="miles-summary-row">
                  <strong>Miles that you already have:</strong>
                  <span>
                    <input
                    type="text"
                    class="input-box"
                    maxlength="15"
                    inputmode="numeric"
                    pattern="[0-9,]*"
                    placeholder="Enter miles"
                    [value]="formattedEnterMiles"
                    (input)="onEnterMilesChange($event)"
                    (keydown)="restrictToNumbersOnly($event)"
                  />                                   
                  
                  </span>
                </div>
              
                <!-- Earned Miles -->
                <div *ngIf="milesYouEarned !== null" class="miles-summary-row">
                  <strong>Total Miles:</strong>
                  <span>{{ milesYouEarned | number: '1.0-0' }}</span>
                </div>
              </div>
                  </div>


                  <div *ngIf="(cashback === false && miles === false)" class="d-flex flex-column justify-content-center" style="min-height: 100%; gap: 16px;">
  
                    <!-- Borrowing Rate Input Section -->
                    <div class="d-flex flex-row align-items-center gap-2">
                      <label for="borrowingRate" class="fw-bold mb-0">Borrowing Rate(%) p.a</label>
                      <div class="borrowing-wrapper d-flex flex-row align-items-center gap-2">
                        <input id="borrowingRate" type="text" class="borrowing-input" maxlength="5" inputmode="decimal"
                          placeholder="e.g. 1" [(ngModel)]="borrowingRate" (ngModelChange)="calculateInterestAmount()"
                          pattern="[0-9]*([.][0-9]+)?"
                          style="text-align: right;"
                          (keydown)="restrictToNumbersOnly($event)" />
                        <span class="suffix-percent">%</span>
                      </div>
                    </div>
                    
                    <div class="text-muted" style="font-size: 0.8rem; margin-top: 10px; max-width: 400px;">
                      If you are using a line of credit or any other form of finance, please input the annualized rate of borrowing, else input 0%
                    </div>
                  
                    <div class="total-info-row" style="margin-top: 20px;">
                      <strong>Your annual expenses:</strong>
                      <span>{{ totalAnnualExpense | number: '1.0-0' }}  <span class="currency-color">{{currencySuffix }}</span></span>
                    </div>
                  
                    <div class="total-info-row" *ngIf="selectedCard && selectedCardTypeValue === 'Business' && totalsavingbusiness !== null">
                      <strong>Savings from Interest p.a:</strong>
                      <span>
                        {{ Math.round(totalsavingbusiness) }} <span class="currency-color">{{ currencySuffix }}</span>
                      </span>
                    </div>
                    
                    <div class="total-info-row" *ngIf="selectedCard && cardFeesPa !== null">
                      <strong>Total Cost (Card Fees: {{ costPercent }}%):</strong>
                      <span>
                        {{ Math.round(cardFeesPa) }} <span class="currency-color">{{ currencySuffix }}</span>
                      </span>
                    </div>
                    
                    <div class="total-info-row" *ngIf="selectedCard && selectedCardTypeValue === 'Business' && netSavingsBusiness !== null">
                      <strong>Net Savings p.a:</strong>
                      <span>
                        {{ Math.round(netSavingsBusiness) }} <span class="currency-color">{{ currencySuffix }}</span>
                      </span>
                    </div>
                  
                  </div>
                  

                
              <!-- Redeemable Trips -->
              <div class="align-items-center mt-1">
                <span *ngIf="availabletrip !== null && milesEarned !== 0" style="font-size: 16px;">
                  Redeem <span style="font-weight: 500;">{{ availabletrip | number: '1.0-0' }}</span> return trip from
                  <span style="font-weight: 500;">{{ tripDetails }}</span>
                </span>
                <span *ngIf="remainingMiles > 0">
                (Remaining: {{ remainingMiles | number: '1.0-0' }} miles)
                </span>
              </div>


            <div *ngIf="(cashback === true && miles === false)" class="cashback-wrapper">
              <div class="d-flex flex-column justify-content-center" style="min-height: 100%; gap: 16px;">
                
                <!-- Annual Expenses -->
                <div class="cashback-row">
                  <strong class="me-1">Your annual expenses: </strong>
                  <span>{{ totalAnnualExpense | number: '1.0-0' }} <span class="currency-color"> {{currencySuffix }}</span></span>
                </div>
            
                <!-- Cashback Rate Input -->
                <div class="cashback-row">
                  <strong class="me-1">Cashback Rate (%) p.a</strong>
                  <div class="cashback-input-wrapper">
                    <input id="cashbackRate" type="text" class="cashback-input" maxlength="5" inputmode="decimal"
                      placeholder="e.g. 1" [(ngModel)]="cashbackRate" (ngModelChange)="calculateCashbackAmount()"
                      pattern="[0-9]*([.][0-9]+)?" style="text-align: right;" (keydown)="restrictToNumbersOnly($event)" />
                    <span class="suffix-percent">%</span>
                  </div>
                </div>

                <!-- Savings from Cashback -->
                <div class="cashback-row" *ngIf="cashbackRate">
                  <strong>Savings from Cash Back:</strong>
                  <span *ngIf="cashbackAmount !== null">
                    {{ Math.round(cashbackAmount)}}<span class="currency-color"> {{currencySuffix }}</span>
                  </span>
                  <span *ngIf="cashbackAmount === null">-</span>
                </div>
            
                <!-- Total Cost (Card Fees) -->
                <div class="cashback-row">
                  <strong>Total Cost (Card Fees: {{costPercent}}%):</strong>
                  <span>
                    {{ Math.round(cardFeesPa)}}<span class="currency-color"> {{currencySuffix }}</span>
                  </span>
                </div>
            
                <!-- Net Savings -->
                <div class="cashback-row" *ngIf="cashbackRate">
                  <strong class="me-1">Net Savings:</strong>
                  <span>
                    {{ Math.round(netSavingsCashback) }}<span class="currency-color"> {{currencySuffix }}</span>
                  </span>
                </div>
                
              </div>

            </div>       
            
          </div>
        </div>
      </div>
    </div>
  </div>